import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance13ujfby7pfhe7 as Companion_getInstance,
  TimeZone3oibfp0mqo4lg as TimeZone,
} from '../TimeZone.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TimeZoneSerializerClass;
function TimeZoneSerializer() {
  if (TimeZoneSerializerClass === VOID) {
    class $ {
      constructor() {
        TimeZoneSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.TimeZone', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance().of_5gnbr7_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_pkxsts_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.get_id_kntnx8_k$());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pkxsts_k$(encoder, value instanceof TimeZone() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'TimeZoneSerializer', VOID, VOID, [KSerializer()]);
    TimeZoneSerializerClass = $;
  }
  return TimeZoneSerializerClass;
}
var TimeZoneSerializer_instance;
function TimeZoneSerializer_getInstance() {
  if (TimeZoneSerializer_instance === VOID)
    new (TimeZoneSerializer())();
  return TimeZoneSerializer_instance;
}
//region block: exports
export {
  TimeZoneSerializer_getInstance as TimeZoneSerializer_getInstance3jcki7eba0f0t,
};
//endregion

//# sourceMappingURL=TimeZoneSerializers.mjs.map
